// pages/BookingQuestions.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import packageJson from "../../package.json";

const BASE_URL = packageJson.apiUrl;

const BookingQuestions = () => {
  const { id } = useParams(); // could be numeric ID OR slug
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [course, setCourse] = useState(null);

  const tokenKey = sessionStorage.getItem("bookingToken");

  // ✅ Step 1: Fetch course
  useEffect(() => {
    const fetchCourse = async () => {
      try {
        let res;
        if (/^\d+$/.test(id)) {
          // numeric -> fetch by ID
          res = await axios.get(`${BASE_URL}/course/${id}`);
        } else {
          // slug -> fetch by slug
          res = await axios.get(`${BASE_URL}/course/${id}`);
        }

        let courseData = null;
        if (res.data.course) courseData = res.data.course;
        else if (res.data.data) courseData = res.data.data;
        else if (res.data.id) courseData = res.data;

        if (!courseData) {
          console.error("❌ No course data found");
          return;
        }

        setCourse(courseData);
        console.log("✅ Fetched course:", courseData);
      } catch (error) {
        console.error("❌ Error fetching course:", error);
      }
    };

    fetchCourse();
  }, [id]);

  // ✅ Step 2: Fetch descriptive questions once slug exists
  useEffect(() => {
    const fetchQuestions = async () => {
      if (!course?.slug) return;

      try {
        const qRes = await axios.get(
          `https://app.endorselearning.co.uk/api/course/descriptive/${course.slug}`
        );
        console.log("📌 Descriptive API Response:", qRes.data);

        let qList = [];
        if (qRes.data.questions_answers) {
          qList = qRes.data.questions_answers;
        } else if (qRes.data.questions) {
          qList = qRes.data.questions;
        } else if (qRes.data.data) {
          qList = qRes.data.data;
        } else if (Array.isArray(qRes.data)) {
          qList = qRes.data;
        }

        setQuestions(qList || []);
      } catch (error) {
        console.error("❌ Error fetching descriptive questions:", error);
      }
    };

    fetchQuestions();
  }, [course?.slug]);

  // ✅ Step 3: Save Q&A
  const handleQuestionSubmit = async (e) => {
    e.preventDefault();
    if (!tokenKey) {
      alert("No booking token, go back to step 1.");
      return;
    }

    const formData = new FormData(e.target);
    let qaObj = {};

    questions.forEach((item, index) => {
      const ans = formData.get(`q${index + 1}`);
      if (ans !== null) {
        qaObj[`q${index + 1}`] = item.question || `Question ${index + 1}`;
        qaObj[`a${index + 1}`] = ans;
      }
    });

    try {
      setLoading(true);
      const res = await fetch(`${BASE_URL}/inhouse/save-question-answer`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token_unique_key: tokenKey,
          question_answer: JSON.stringify(qaObj),
        }),
      });

      const data = await res.json();
      if (!data.success) throw new Error("Failed to save answers");

      navigate(`/booking/${id}/payment`);
    } catch (err) {
      alert("Error: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="section-space">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <div class="login-box">
            <div className="login-left">
            <form onSubmit={handleQuestionSubmit}>
              <h3 className="login-title">Step 2: Answer Questions</h3>
              {questions.length > 0 ? (
                questions.map((q, index) => (
                  <div key={index} style={{ marginBottom: "15px" }}>
                    <label className="label-top">{q.question || `Question ${index + 1}`}</label>
                    <select className="form-control form-select" name={`q${index + 1}`} required>
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                ))
              ) : (
                <p>Loading questions...</p>
              )}

              <div className="text-center">
                <button className="btn btn-green" type="submit" disabled={loading}>
                {loading ? "Saving..." : "Next: Payment"}
              </button>
              </div>
            </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    </section>
  );
};

export default BookingQuestions;
